import '../App.css';
import React from 'react';

const Done = () => (
	<div className="app-content" data-testid="welcome-component">
		<h1 className="welcome-title">You are all done!</h1>
	</div>
);

export default Done;
